import * as React from 'react';
import MainMobileTopup from '../../components/topup/MainMobileTopup';
import { useNavigate } from 'react-router-dom';
import Storage from '../../services/Storage';

export default function MobileTopup() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])

  return (
    <MainMobileTopup></MainMobileTopup>
  );
}